import React, { useState } from "react";

import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { Formik, Form, Field } from "formik";
import PropTypes from "prop-types";
import { OutlineTextField } from "../../FormikCustoms";
import FormModal from "../../FormModal";
// import { validateCNH } from "../../../utils/validateCNH";

function ModalEdit({ open, handleClose, handleUpdate, getDriver, editedData }) {
    const [selectedDriver, setSelectedDriver] = useState({});
    const [feedback, setFeedback] = useState({});
    const [disabledSubmit, setDisabledSubmit] = useState(false);

    const handleOnFeedback = () => {
        if (feedback.success) {
            handleOnclose();
        } else {
            setFeedback({});
        }
    };

    const onGetDriver = async (document) => {
        if (document) {
            const driver = await getDriver(document);
            if (driver && driver.name) {
                setSelectedDriver(driver);
                return;
            }
        }
        setSelectedDriver({});
    }

    const handleOnclose = () => {
        handleClose();
        setFeedback({});
    };

    const handleOnSubmit = async (values, setSubmitting) => {
        setDisabledSubmit(true);
        const operationFeedback = await handleUpdate(values);
        setSubmitting(false);
        if (operationFeedback) {
            setFeedback(operationFeedback);
        }
        setDisabledSubmit(false);
    };


    const validateForm = (values) => {
        const errors = {};

        if (!values.truck_plate) {
            errors.truck_plate = "Placa do Caminhão é necessária";
        }

        if (!values.driver_name && !selectedDriver.name) {
            errors.driver_name = "Nome do Motorista é necessário";
        }

        if (!values.driver_document) {
            errors.driver_document = "CNH é necessária";
        }

        /* const isEnableCNHValidation = process.env.REACT_APP_ENABLE_CNH_VALIDATION ?? true;
        const isCnhValid = isEnableCNHValidation ? validateCNH(values.driver_document) : true;

        if (!values.driver_document && !isCnhValid) {
            errors.driver_document = "CNH do Motorista precisa ser válida";
        } */

        return errors;
    };

    return (
        <FormModal
            title="Editar agendamento"
            open={open}
            handleClose={handleOnclose}
        >
            {!Object.keys(feedback).length ? (
                <Formik
                    initialValues={{
                        id: editedData?.id ?? null,
                        driver_name: editedData?.driver_name ?? "",
                        driver_document: editedData?.driver_document ?? "",
                        truck_plate: editedData?.truck_plate ?? "",
                    }}
                    validate={(values) => validateForm(values)}
                    onSubmit={(values, { setSubmitting }) => {
                        const sendValues = selectedDriver.name ?
                            {
                                ...values,
                                driver_name: selectedDriver.name
                            } :
                            values;
                        handleOnSubmit(sendValues, setSubmitting);
                    }}
                >
                    {({ submitForm, isSubmitting, values }) => (
                        <Form>
                            <Grid container spacing={3} justifyContent="space-between">
                                <Grid item md={6} xs={12}>
                                    <Field
                                        component={OutlineTextField}
                                        name="truck_plate"
                                        type="text"
                                        label="Placa do Caminhão *"
                                        mask="*******"
                                        maskplaceholder=""
                                        data-cy="scheduling-truck-plate"
                                        id="scheduling-truck-plate"
                                        value={
                                            values.truck_plate
                                                ? values.truck_plate.toUpperCase()
                                                : ""
                                        }
                                    />
                                </Grid>
                                <Grid item md={6} xs={12}>
                                    <Field
                                        component={OutlineTextField}
                                        name="driver_document"
                                        type="text"
                                        label="CNH Motorista *"
                                        data-cy="scheduling-cnh"
                                        id="scheduling-cnh"
                                        mask="99999999999"
                                        maskplaceholder=""
                                        value={values.driver_document}
                                        onBlur={() => onGetDriver(values.driver_document)}
                                    />
                                </Grid>
                                <Grid item md={6} xs={12}>
                                    <Field
                                        component={OutlineTextField}
                                        name="driver_name"
                                        type="text"
                                        label="Nome do motorista *"
                                        data-cy="scheduling-name"
                                        id="scheduling-name"
                                        disabled={!!selectedDriver.name}
                                        value={
                                            selectedDriver.name
                                                ? selectedDriver.name
                                                : values.driver_name
                                        }
                                    />
                                </Grid>
                                <Grid item md={4} xs={12}>
                                    <div
                                        style={{
                                            display: "flex",
                                            height: 56,
                                            justifyContent: "flex-end",
                                        }}
                                    >
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            style={{ minWidth: "100%" }}
                                            disabled={isSubmitting || disabledSubmit}
                                            data-cy="scheduling-update"
                                            id="scheduling-update"
                                            onClick={submitForm}
                                            size="large"
                                        >
                                            Atualizar
                                        </Button>
                                    </div>
                                </Grid>
                            </Grid>
                        </Form>
                    )}
                </Formik>
            ) : (
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Typography variant="h5">{feedback.message}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <div
                                style={{
                                    display: "flex",
                                    height: 56,
                                    justifyContent: "flex-end",
                                }}
                            >
                                <Button
                                    onClick={handleOnFeedback}
                                    variant="contained"
                                    color="primary"
                                    data-cy="back-btn"
                                    id="back-btn"
                                    style={{ minWidth: "50%" }}
                                    size="large"
                                >
                                    {feedback.success ? "Voltar" : "Tentar novamente"}
                                </Button>
                            </div>
                        </Grid>
                    </Grid>
                )}
        </FormModal>
    );
}

ModalEdit.defaultProps = {
    editedData: {},
};

ModalEdit.propTypes = {
    editedData: PropTypes.object,
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    handleUpdate: PropTypes.func.isRequired,
    getDriver: PropTypes.func.isRequired
};

export default ModalEdit;
